<style src="./Bento.scss" lang="scss"></style>

<script>
  import Simple from '@/components/Simple/Simple'
  import vClickOutside from 'v-click-outside'

  /**
   * Bento menu
   * @vue-prop {Object[]} elements An array of bento-tile objects
   * @vue-prop {Object[]} footer An array of footer element objects
   * @vue-data {Boolean} isOpen indicates whether the menu is shown or not
   */
  export default {
    name: 'HpBento',
    props: {
      elements: Array,
      footer: Array
    },
    data () {
      return {
        isOpen: false
      }
    },
    components: {
      'hp-simple': Simple
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    methods: {
      close () {
        this.isOpen = false
      },
      onElementClick (element) {
        this.close()
        this.$emit('change', element)
      },
      checkClicks () {
        let clickCount = 0

        this.$el.querySelector('label')?.addEventListener('click', () => {
          clickCount++

          if (clickCount === 50) {
            this.$el.classList.add('rotate')

            setTimeout(() => {
              this.$el.classList.remove('rotate')
              clickCount = 0
            }, 1000)
          }
        })
      }
    },
    mounted () {
      this.checkClicks()
    }
  }
</script>

<template>
  <div data-component="bento" :data-open="isOpen || false" v-click-outside="close">
    <label @click="isOpen = !isOpen">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </label>
    <div v-if="isOpen" data-layer>
      <label @click="close" data-close-button data-grid-end-self>
        <span></span>
        <span></span>
      </label>
      <div data-grid-row data-part="bento-row">
        <hp-simple v-for="(element, index) in elements" :key="index" v-bind="element" @click="onElementClick(element)"
          data-part="bento-tile"></hp-simple>
      </div>
      <div data-grid-row data-part="bento-row">
        <a :href="el.href" :key="index" v-for="(el, index) in footer">{{ el.text }}</a>
      </div>
    </div>
  </div>
</template>
